import { ArrowRight } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=2400&q=80";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex flex-col justify-end overflow-hidden grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/85 via-[#0A0A0A]/55 to-[#0A0A0A]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(240,196,107,0.14),_transparent_55%)]" />

      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 sm:px-12 lg:px-16 pt-32 sm:pt-40">
        <div className="flex items-center gap-4 text-[10px] sm:text-xs font-mono tracking-[0.35em] text-white/50 uppercase">
          <span className="h-px w-10 bg-gold" />
          <span>Property Advice You Can Trust</span>
        </div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 sm:px-12 lg:px-16 pb-20 sm:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <h1
            data-testid="hero-headline"
            className="lg:col-span-8 font-display text-[14vw] sm:text-[10vw] lg:text-[7.6vw] leading-[0.88] tracking-[-0.02em] text-white reveal"
          >
            No emotion.
            <br />
            <span className="text-white/50 italic">Only</span>{" "}
            <span className="text-gold">logic</span>
            <br />
            for wealth.
          </h1>

          <div className="lg:col-span-4 space-y-8 reveal" style={{ animationDelay: "200ms" }}>
            <p className="text-white/75 text-base sm:text-lg leading-relaxed max-w-md">
              We help everyday people grow real wealth through property —
              <span className="text-white"> using simple numbers, not hype.</span>{" "}
              No jargon. No pressure. Just clear advice.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="#pricing"
                data-testid="hero-cta-primary"
                className="group inline-flex items-center gap-3 bg-gold text-ink px-8 py-4 text-[11px] tracking-[0.3em] uppercase font-semibold hover:bg-gold-dark transition-colors"
              >
                See the Plans
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="#how-we-think"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2 text-white/70 text-[11px] tracking-[0.3em] uppercase border-b border-white/20 hover:border-gold hover:text-gold pb-1 transition-colors"
              >
                How It Works
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 sm:mt-20 border-t border-white/10 pt-6 flex flex-wrap items-center gap-x-10 gap-y-3 font-mono text-[11px] tracking-[0.2em] uppercase text-white/60">
          <span className="flex items-center gap-2">
            <span className="h-2 w-2 bg-gold rounded-full animate-pulse" />
            <span>Only 7 spots left this quarter</span>
          </span>
          <span className="text-white/30">|</span>
          <span>Deals updated daily</span>
          <span className="text-white/30 hidden sm:inline">|</span>
          <span className="hidden sm:inline">Cancel any time</span>
        </div>
      </div>
    </section>
  );
}
